import { render } from "./brandPcIndex.vue?vue&type=template&id=bc54c718"
import script from "./brandPcIndex.vue?vue&type=script&lang=js"
export * from "./brandPcIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__